jQuery(document).ready(function(){
    let $recommended_languages = jQuery("[data-modal-id=\"languages-recommend\"]");
    if($recommended_languages.length){
        jQuery(document).trigger('open_modal', ['languages-recommend']);
    }
})